<template>
<div class="chapter">
<div class="inner_page">
<p class="P_WFP_ChapHead" id="auto_bookmark_table_of_contents_1"><span>Author’s Note</span></p>
<p class="P_WFP_BodyTextFirstPara">Although this is a book of fiction, it is based on historical figures, events, and locations that are real. However, it is impossible to precisely reconstruct the thoughts and motivations of these historical figures and their actions. In addition, the author has taken liberty to dramatically embellish historical events. For example, although Soviet Ilyushin Il-28s were present in Cuba during the 1962 missile crisis, Chinese Il-28s were not. As another example, although I received pointers on the POW scenes in Vietnam, not all events herein occurred in the manner depicted. I did this not to denigrate, but only highlight and humanize the significance of these actions. In addition, although the cheating scandal of 1965 did occur, the discovery of the scandal did not happen in the manner depicted; “call signs” for Air Force pilots were not widely used in the 1960s and early 1970s, but for continuity I used them throughout the book; and High Country Construction, Colorado Technical Associates, and the USAFA’s Department of Theoretical Mechanics did not exist. Finally, only to dramatize the novel, some anecdotes may be out of chronological order (such as an F-105 going supersonic over the Terrazzo, the Vietnam protests at the Cadet Chapel, etc.), the sole purpose being to not make this novel a dry chronicle of historical fact, but rather to show the true excitement of the evolution of a major American institution, the United States Air Force Academy.</p>
<p class="P_WFP_BodyTextFirstPara"> </p>
<p class="P_WFP_BodyTextFirstPara__And__Centre_Alignment"><span>www.DougBeason.com</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0006.vue?e6f63a76